import { z } from 'zod'

export const ChakraThemeKeySchema = z.enum(['aer_lingus', 'british_airways', 'avios'])

export type ChakraThemeKey = z.infer<typeof ChakraThemeKeySchema>
